import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }

import {
  IonLoading,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonPage,
  IonFooter,
  IonNote,
  IonSelect,
  IonSelectOption,
  IonContent,
  IonList,
  IonLabel,
  IonItem,
  IonInput,
  IonButton,
  onIonViewWillEnter,
  alertController,
} from "@ionic/vue";
import { closeCircle, save } from "ionicons/icons";
import countries from "countries-list";
import { useVisitors } from ".";
import { useRoute } from "vue-router";
import { deleteVisitor } from "@/api/visitors";
import { useToasters } from "@/composition/toasters";
import router from "@/router";
import { handleError } from "@/views";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditVisitor',
  setup(__props) {

const countriesOptions = Object.keys(countries.countries).map((key) => ({
  label: countries.countries[key].name,
  value: key,
}));

const route = useRoute();
const toasters = useToasters();
const { state, form, data, loadVisitorInfo, update } = useVisitors();

const visitor_id = parseInt(route.params.visitor_id as string, 10);
const event_id = parseInt(route.params.event_id as string, 10);

const updateVisitor = () => {
  update().then(() => {
    router.push(`/event/${event_id}/visitors`);
  })
}
const deleteVisitorPrompt = async () => {
  const alert = await alertController.create({
    header: "Are you sure?",
    buttons: [
      {
        text: "Cancel",
        role: "cancel",
      },
      {
        text: "Delete",
        role: "confirm",
        handler: () => {
          deleteVisitor(data.value)
            .then(() => {
              toasters.addSuccess(
                `Visitor ${data.value.name} deleted successfuly`
              );
              router.push(`/event/${event_id}/visitors`);
              alert.remove();
            })
            .catch(handleError);
        },
      },
    ],
  });

  await alert.present();
};

onIonViewWillEnter(() => {
  loadVisitorInfo(visitor_id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': _unref(state).errors.name.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Name")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        placeholder: "John Doe",
                        modelValue: _unref(form).name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.name, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `name-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': _unref(state).errors.email.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "email",
                        placeholder: "john.doe@gmail.com",
                        modelValue: _unref(form).email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).email) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.email, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `email-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
              'ion-invalid': _unref(state).errors.phone_number.length > 0,
            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Phone number")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "tel",
                        placeholder: "+1 123 456 7890",
                        modelValue: _unref(form).phone_number,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).phone_number) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.phone_number, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `phone-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
              'ion-invalid': _unref(state).errors.birthdate.length > 0,
            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Birth date")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "date",
                        placeholder: "Microsoft",
                        modelValue: _unref(form).birthdate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).birthdate) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.birthdate, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `phone-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
              'ion-invalid': _unref(state).errors.company.length > 0,
            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Company")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "text",
                        placeholder: "Company Name",
                        modelValue: _unref(form).company,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).company) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.company, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `company-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': _unref(state).errors.country.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Country")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSelect), {
                        placeholder: "Select your country",
                        modelValue: _unref(form).country,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).country) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countriesOptions), (option) => {
                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                              value: option.value,
                              key: `country-option-${option.value}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.country, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `job-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
              'ion-invalid': _unref(state).errors.job_title.length > 0,
            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Job title")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "text",
                        placeholder: "Lead Software Developer",
                        modelValue: _unref(form).job_title,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).job_title) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.job_title, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `job-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_unref(state).visitor_types.length > 0)
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 0,
                        class: _normalizeClass({
              'ion-invalid': _unref(state).errors.visitor_type.length > 0,
            })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Visitor type")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonSelect), {
                            placeholder: "Select visitor type",
                            modelValue: _unref(form).visitor_type,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).visitor_type) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).visitor_types, (visitor_type) => {
                                return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                  value: visitor_type.id,
                                  key: `visitor-type-${visitor_type.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(visitor_type.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.visitor_type, (message, i) => {
                            return (_openBlock(), _createBlock(_unref(IonNote), {
                              slot: "error",
                              key: `type-error-${i}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(message), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonButton), {
            fill: "clear",
            color: "danger",
            expand: "block",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteVisitorPrompt()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete visitor ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("section", null, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "light",
                            "router-link": `/event/${_unref(event_id)}/visitor/${_unref(visitor_id)}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(closeCircle)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Cancel ")
                            ]),
                            _: 1
                          }, 8, ["router-link"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "success",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (updateVisitor()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(save)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Save ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(state).loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})